
import { Component, Vue } from 'vue-property-decorator';
import Themeable from 'vuetify/lib/mixins/themeable';
import { BaseProfileDataInterface, ProfileRepositoryInterface } from '@/services/Users-profile/interfaces';
import { ProfileMapInterface } from '@/services/QC-V2/chat/interfaces';
import AddAgentsDialog from '@/components/dialogs/dossier/team/AddAgentsDialog.vue';
import { UserBaseInfoInterface, UserRepoInterface } from '@/services/Users/Interfaces';
import RemoveAgentDialog from '@/components/dialogs/dossier/team/RemoveAgentDialog.vue';
import DossierUserRepositoryInterface, { AgentInterface } from '@/services/Dossier/user/interfaces';
import DossierTeamRepositoryInterface, { TeamInterface } from '@/services/Dossier/team/interfaces';
import DossierMembershipRepositoryInterface, {
  CreateMembershipsInterface,
} from '@/services/Dossier/membership/interfaces';

@Component({
  components: { RemoveAgentDialog, AddAgentsDialog },
  mixins: [
    Themeable,
  ],
  inject: [
    'dossierUserRepository',
    'dossierTeamRepository',
    'dossierMembershipRepository',
    'profileRepository',
    'userRepository',
  ],
})
export default class AllTeams extends Vue {
  private dossierUserRepository!: DossierUserRepositoryInterface;
  private dossierTeamRepository!: DossierTeamRepositoryInterface;
  private dossierMembershipRepository!: DossierMembershipRepositoryInterface;
  private profileRepository!: ProfileRepositoryInterface;
  private userRepository!: UserRepoInterface;

  private loading: boolean = true;

  private users: AgentInterface[] = [];
  private teams: TeamInterface[] = [];
  private profilesMap: ProfileMapInterface = {};
  private usersMap: { [key: string]: UserBaseInfoInterface } = {};

  private addAgentsDialogVisible: boolean = false;
  private teamIdForAddAgentsDialogDialog: number = 0;
  private managerNameForAddAgentsDialog: string = '';

  private removeAgentDialogVisible: boolean = false;
  private managerForRemoveDialog!: BaseProfileDataInterface;
  private profileForRemoveDialog!: BaseProfileDataInterface;

  private async created(): Promise<void> {
    await this.initialize();
  }

  private async initialize(): Promise<void> {
    try {
      this.users = await this.dossierUserRepository.getAllFreeUsers();
      this.teams = await this.dossierTeamRepository.getAllTeams();
      await this.getUsersProfiles();
      this.loading = false;
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

  private async getUsersProfiles(): Promise<void> {
    const ids: string[] = [];
    this.teams.forEach((team) => {
      if (!ids.includes(team.manager.id)) {
        ids.push(team.manager.id);
      }

      if (!team.memberships || !team.memberships.length) {
        return;
      }

      team.memberships.forEach((membership) => {
        if (!ids.includes(membership.user.id)) {
          ids.push(membership.user.id);
        }
      });
    });

    this.users.forEach((user) => {
      if (!ids.includes(user.id)) {
        ids.push(user.id);
      }
    });

    const users = await this.userRepository.getUsersByIds(ids);
    users.forEach((user) => {
      this.usersMap[user.id] = user;
    });

    const profiles = await this.profileRepository.getBaseProfileDataByUsersIds(ids);
    profiles.forEach((profile) => {
      this.profilesMap[profile.userId] = profile;
    });
  }

  private async createTeam(): Promise<void> {
    await this.$router.push({ name: 'create-team' });
  }

  private async openMembershipDialog(team: TeamInterface): Promise<void> {
    this.teamIdForAddAgentsDialogDialog = team.id;
    this.managerNameForAddAgentsDialog =
      `${this.profilesMap[team.manager.id].firstName} ${this.profilesMap[team.manager.id].lastName}`;
    this.addAgentsDialogVisible = true;
  }

  private async addTeamAgents(data: CreateMembershipsInterface): Promise<void> {
    try {
      await this.dossierMembershipRepository.createMemberships(data);
      await this.initialize();
      this.$successDialog.show('Agents added successfully!');
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }


  private showRemoveMembershipDialog(managerId: string, userId: string): void {
    this.managerForRemoveDialog = this.profilesMap[managerId];
    this.profileForRemoveDialog = this.profilesMap[userId];
    this.removeAgentDialogVisible = true;
  }

  private async removeAgentFromTeam(userId: string): Promise<void> {
    try {
      await this.dossierMembershipRepository.removeMembership(userId);
      this.teams.forEach((_, index) => {
        this.teams[index].memberships = this.teams[index].memberships
          .filter((membership) => membership.user.id !== userId);
      });
      this.$successDialog.show('Agent successfully removed!');
    } catch (e) {
      this.$errorDialog.show(e?.response?.data?.message || e.message);
    }
  }

}
